import ProductService from '../services/product.service'

export const productModule = {
  namespaced: true,

  state: {
    products: [],
    productDetail: null,
    product: null,
    structure: null,
    violations: null,
    invalidData: null
  },

  actions: {

    async search ({ commit }, criterias) {
      return ProductService.search(criterias).then(
        response => {
          const products = response.data.productList
          commit('searchSuccess', products)
          return Promise.resolve(products)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async detail ({ commit }, criterias) {
      if (criterias.idDistributeur === 'GCD') {
        criterias.idDistributeur = '99999'
      }
      return ProductService.detail(criterias).then(
        response => {
          if (response.data.productDescription !== null) {
            const accountDetail = response.data.productDescription
            accountDetail.splice(3, 1)
            accountDetail.splice(4, 1)
            commit('detailSuccess', accountDetail)
            return Promise.resolve(accountDetail)
          }
          else {
            return Promise.reject(response.data)
          }
        },
        error => {
          commit('detailFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async extract ({ commit }, fileToControl) {
      return ProductService.extract(fileToControl).then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async export ({ commit }) {
      return ProductService.export().then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
              error.response.data = reader.result
              resolve(Promise.reject(error))
            }

            reader.onerror = () => {
              reject(error)
            }

            reader.readAsText(error.response.data)
          })
        }
      )
    },

    async create ({ commit }, criterias) {
      return ProductService.create(criterias).then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async structure ({ commit }) {
      return ProductService.structure().then(
        response => {
          const structure = response.data
          // Hide PRL and PRA because it is not used
          structure.splice(3, 1)
          structure.splice(4, 1)
          commit('structureSuccess', structure)
          return Promise.resolve(structure)
        },
        error => {
          commit('structureFailure')
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async createProduct ({ commit }, criterias) {
      return ProductService.createProduct(criterias).then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async updateProduct ({ commit }, criterias) {
      return ProductService.updateProduct(criterias).then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async createdProductsLastMonth ({ commit }) {
      return ProductService.createdProductsLastMonth().then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async createdProductsCurrentMonth ({ commit }) {
      return ProductService.createdProductsCurrentMonth().then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async editedProductsLastMonth ({ commit }) {
      return ProductService.editedProductsLastMonth().then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async editedProductsCurrentMonth ({ commit }) {
      return ProductService.editedProductsCurrentMonth().then(
        response => {
          const result = response.data
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async resetDetail ({ commit }) {
      commit('detailReset')
    },

    async resetStructure ({ commit }) {
      commit('structureReset')
    },

    async setProduct ({ commit }, product) {
      commit('productSuccess', product)
    },

    async setViolations ({ commit }, violations) {
      commit('violationsError', violations)
    },

    async resetViolations ({ commit }) {
      commit('violationsError', null)
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }
  },

  mutations: {
    searchSuccess (state, products) {
      state.products = products
    },
    searchFailure (state) {
      state.products = []
    },
    listReset (state) {
      state.products = []
    },
    detailSuccess (state, productDetail) {
      state.productDetail = productDetail
    },
    detailFailure (state) {
      state.productDetail = null
    },
    detailReset (state) {
      state.productDetail = null
    },
    productSuccess (state, product) {
      state.product = product
    },
    structureSuccess (state, structure) {
      state.structure = structure
    },
    structureFailure (state) {
      state.structure = null
    },
    structureReset (state) {
      state.structure = null
    },
    violationsError (state, violations) {
      state.violations = violations
    },
    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
